<template><div><h1 id="datenauskunft-report" tabindex="-1"><a class="header-anchor" href="#datenauskunft-report"><span>Datenauskunft (Report)</span></a></h1>
<p>Datenauskunft (Report) — Bericht mit gespeicherten Daten einer Person</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Jede Person kann Auskunft darüber verlangen, ob Personendaten über sie bearbeitet werden. Hierfür stellt funtrade einen Report über die in der Datenbank gespeicherten Daten zur Verfügung. Dabei handelt es sich um einen standardisierten Report. Organisationsspezifische Anpassungen/Erweiterungen sind, nach Absprache mit Arenae, möglich.</p>
<p>Folgende Daten zur Person werden ausgewiesen:</p>
<p>- Personendaten (Name, Vorname, Titel, Geburtsdatum Geschlecht), Sperren, Adressquelle (Standardquelle aus der Quellengeschichte), Notizen, Adressen (alle, auch die ungültigen), Beziehungen, Merkmale und Merkmalattribute, Ereignisse, Aktionen, Zusagen, Zahlungsverbindungen, manuelle Buchungen, aktive Publikationen, Korrespondenzen, Veranstaltungspositionen (mit Rollen, Merkmalen und Bemerkungen), Nachlassdaten (mit Zugehörigen Rollen).</p>
<p>Zusätzlich gibt es, unter <RouteLink to="/referenz/refs/ft.refdata.do-text.html" title="Text- und Bildelemente">Texte und Bilder</RouteLink> vordefinierte Texte, die in den Report übernommen werden:</p>
<table>
<thead>
<tr>
<th>Code</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>DS_Aufbewahrung</td>
<td>Genereller Hinweis zur Aufbewahrungsdauer</td>
</tr>
<tr>
<td>DS_Bearbeitungszweck</td>
<td>Hinweis zum Bearbeitungszweck</td>
</tr>
<tr>
<td>DS_Verantwortung</td>
<td>Name und Kontaktdaten der/des Datenschutzverantwortlichen</td>
</tr>
<tr>
<td>DS_Weitergabe</td>
<td>Information zur Weitergabe von Personendaten an Dritte</td>
</tr>
</tbody>
</table>
<p>Diese Datenauskunft ist auch für Fremdadressen anwendbar.</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Personen: → Datenausgabe → Datenauskunft</p>
<p><strong>Parameter</strong></p>
<p>Der Startdialog funktioniert zweistufig. Nach der Zuweisung einer Person kann der Text zu der Quelle editiert und bei Bedarf eine Bemerkung erfasst werden.</p>
<dl>
<dt>zu Person</dt>
<dd>Person, deren Daten abgebildet werden.</dd>
<dt>Datum</dt>
<dd>Erfassungs-/Übernahmedatum aus <a class="link" href="ft.refdata.personquelle.html" title="Quellen zur Person">Quellen zur Person</a>.<br>Datum und Quelle werden wie folgt ermittelt:<br>Datum früheste Quelle ist kleiner oder gleich Erfassungsdatum Person und 1. (Fremd-)Ereignis: Erfassunsdatums = Datum füheste Quelle, Quelle = früheste Quelle<br>Datum früheste Quelle ist grüsser ale Erfassungsdatum Person und 1. (Fremd-)Ereignis: Erfassungsdatum = frühestes Datum, aus Erfassungsdatum Person oder 1. (Fremd-)Ereignis, Quelle = ''</dd>
<dt>Quelle</dt>
<dd>Standard-Quelle aus <a class="link" href="ft.refdata.personquelle.html" title="Quellen zur Person">Quellen zur Person</a>. Übernommen wird die Beschreibung (wenn die Beschreibung fehlt, wird der Code eingetragen). Im Startdialog des Jobs wird die Quelle angezeigt. Der Text kann bei Bedarf überschrieben werden.</dd>
<dt>Bemerkungen</dt>
<dd>Beliebiger Text, der im Report angezeigt wird.</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>Keine, es wird nur ein Report produziert.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/datenschutz/datenschutz.html" title="Kapitel 9. Datenschutz">Datenschutz</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.personquelle.html" title="Quellen zur Person">Quellen zur Person</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.do-text.html" title="Text- und Bildelemente">Texte und Bilder</RouteLink></p>
</div></template>


